import React from 'react'
import { Row, Col, FormGroup, Label, Input } from 'twyne-new.ui';

const React2Form = ({data, onChange, disabled}) => {
  return (
    <Row>
      <Col size="4">
        <FormGroup>
          <Label>Site ID</Label>
          <Input type="text" value={data.siteid || ''}
            onChange={(e) => onChange('siteid', e.target.value)} disabled={disabled}
          />
        </FormGroup>
      </Col>
      <Col size="4">
        <FormGroup>
          <Label>Publisher ID</Label>
          <Input type="text" value={data.publisherid || ''}
            onChange={(e) => onChange('publisherid', e.target.value)} disabled={disabled}
          />
        </FormGroup>
      </Col>
      <Col size="4">
        <FormGroup>
          <Label>Security Key</Label>
          <Input type="text" value={data.securitykey || ''}
            onChange={(e) => onChange('securitykey', e.target.value)} disabled={disabled}
          />
        </FormGroup>
      </Col>
    </Row>
  );
}

export default React2Form;